<template>
  <div>
    <v-layout row wrap fluid justify-center>
      <v-container fluid>
        <v-layout row wrap justify-center>
          <v-flex hidden-sm-and-down>
            <v-spacer></v-spacer>
          </v-flex>
          <v-btn @click="refreshPage()" class="btnDefault" small color="primary white--text"> <v-icon small left color="white">cached</v-icon>Aggiorna </v-btn>
        </v-layout>
        <v-flex grow text-xs-center>
          <h4 class="primary--text font-weight-bold text-uppercase pt-1">NOTIFICHE</h4>
        </v-flex>

        <v-layout row wrap justify-center>
          <v-icon class="hidden-sm-and-down mr-3" left>search</v-icon>
          <v-flex xs3 ma-1 style="px-1">
            <v-text-field v-model="search" box item-text="Descrizione" label="Cerca" clearable hide-details></v-text-field>
          </v-flex>
          <v-flex xs2 ma-1 style="px-1">
            <v-autocomplete v-model="notificaDefault" @change="filtraTipoMessaggio" :items="tipiMessaggio" clearable label="Tipo notifica" box hide-details></v-autocomplete>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
        <v-layout column>
          <v-data-table
            :rows-per-page-items="[25, 50, { text: 'Tutti', value: -1 }]"
            :headers="headers"
            :items="notificheFiltrate"
            :search="search"
            class="elevation-1 mt-3 noselect"
          >
            <template v-slot:items="props">
              <td>
                {{ formatDate(props.item.DataMessaggio) }}
              </td>
              <td>{{ props.item.TipoMessaggio }}</td>
              <td>{{ props.item.TitoloMessaggio }}</td>
              <td>{{ props.item.Messaggio }}</td>
              <td class="text-xs-right">
                <v-tooltip v-if="props.item.TipoMessaggio === 'WEBLINK'" top>
                  <v-btn slot="activator" @click="azioniNotifiche('link', props.item)"
                   small outline icon class="mr-0" color="purple">
                    <v-icon small color="purple">save</v-icon>
                  </v-btn>
                  <span>Apri link</span>
                </v-tooltip>
                <v-tooltip v-if="props.item.TipoMessaggio === 'WEBVIEW'" top>
                  <v-btn slot="activator" @click="azioniNotifiche('page', props.item)" small outline icon class="mr-0" color="green">
                    <v-icon small color="green">save</v-icon>
                  </v-btn>
                  <span>Vai alla pagina</span>
                </v-tooltip>
                <v-tooltip v-if="props.item.TipoMessaggio === 'DOWNLOAD'" top>
                  <v-btn slot="activator" @click="azioniNotifiche('download', props.item)" small outline icon class="mr-0" color="red">
                    <v-icon small color="red">save</v-icon>
                  </v-btn>
                  <span>Download</span>
                </v-tooltip>
              </td>
            </template>
            <template v-slot:no-results>
              <v-alert :value="true" color="error" icon="warning"> Your search for "{{ search }}" found no results. </v-alert>
            </template>
          </v-data-table>
        </v-layout>
      </v-container>
    </v-layout>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import Util from '@/util';
  import store from '@/store/store';
  import { bus } from '@/main';
  import Vue from 'vue';
  import NotificheEntity from '../gestione/NotificheEntity';
  import FiltroEntity from '../gestione/FiltroEntity';
  export default {
    data: () => ({
      Util,
      search: '',
      filtraStato: 'all',
      notificaDefault: null,
      cardTitle: null,
      cardText: null,
      icon: null,
      buttonText: null,
      isInviaDialog: false,
      isEliminaDialog: false,
      isNonModificabile: false,
      campiNonCompleti: false,
      notificheFiltrate: [],
      notificheObj: new NotificheEntity(),
      filtroObj: new FiltroEntity(),
      DataSistemaStr: new Date().toISOString().substr(0, 10),
      tipiMessaggio: ['WEBVIEW', 'WEBLINK', 'SHOWTEXT', 'DOWNLOAD'],
      selectTipiMessaggio: ['WEBLINK', 'SHOWTEXT'],
      headers: [
        { text: 'Data messaggio', align: 'left', value: 'DataMessaggio', sortable: false },
        { text: 'Tipo messaggio', align: 'left', value: 'TipoMessaggio', sortable: false },
        { text: 'Titolo messaggio', align: 'left', value: 'TitoloMessaggio', sortable: false },
        { text: 'Messaggio', align: 'left', value: 'Messaggio', sortable: false },
        { text: 'Azioni', align: 'right' },
      ],
    }),

    computed: {
      ...mapGetters(['userData']),
      ...mapGetters('notificheModule', ['getNotifiche']),

      notifiche() {
        return this.getNotifiche;
      },
    },

    watch: {
      notifiche() {
        this.notificheFiltrate = this.notifiche;
        this.notificheFiltrate = this.filterNotifiche(this.filtroObj);
      },
      filtraStato() {
        this.filtroObj.Stato = this.filtraStato;
        this.notificheFiltrate = this.filterNotifiche(this.filtroObj);
      },
    },

    created() {
      const vm = this;
      vm.caricaNotifiche();
      vm.filterNotifiche(vm.filtroObj);

      bus.$on('closeDialog', function (value) {
        if (value) {
          vm.closeDialog();
        }
      });
    },

    methods: {
      ...mapActions('notificheModule', ['loadNotifiche', 'createNotificaPush', 'updateNotificaPush', 'deleteNotificaPush', 'inviaNotificaPush']),
      ...mapActions('eventiModule', ['loadInvito', 'exportClassificaPDF', 'loadPiazzola']),
      caricaNotifiche() {
        this.loadNotifiche();
      },

      refreshPage() {
        window.location.reload();
      },

      filtraTipoMessaggio() {
        this.filtroObj.TipoMessaggio = this.notificaDefault;
        this.notificheFiltrate = this.filterNotifiche(this.filtroObj);
      },

      filterNotifiche(filtroObj) {
        let notificheFiltrati = [];
        notificheFiltrati = this.notifiche;

        if (filtroObj.TipoMessaggio) {
          notificheFiltrati = notificheFiltrati.filter((i) => {
            return i.TipoMessaggio == filtroObj.TipoMessaggio;
          });
        }
        return notificheFiltrati;
      },

      confermaAzione(item) {
        if (item.bottone == 'nuovo') {
          this.createNotificaPush(item);
        }
        if (item.bottone == 'modifica') {
          this.updateNotificaPush(item);
        }
        if (item.bottone == 'invia') {
          this.inviaNotificaPush({ idMessaggio: item.idMessaggio });
        }
        if (item.bottone == 'elimina') {
          this.deleteNotificaPush(item);
        }
      },

      azioniNotifiche(t, item) {
        const vm = this;
        if (t == 'download') {
            var splitString = item.AzioneMessaggio.split('/')
            var id = splitString[1]
          if(item.AzioneMessaggio.includes('invito')){
            this.loadInvito(parseInt(id));
          }
          if(item.AzioneMessaggio.includes('classifica')){
            this.exportClassificaPDF(parseInt(id));
          }
          if(item.AzioneMessaggio.includes('piazzola')){
            this.loadPiazzola(parseInt(id))
          }
        }
        if (t == 'link') {
          window.open(item.AzioneMessaggio);
        }
        if (t == 'page') {
          let result = item.AzioneMessaggio.replaceAll("§", "/");
          this.$router.replace({
          path: '/'+result,
        });
        } 
      },

      formatDate(date) {
        let retVal = '';
        if (date) retVal = Util.formattaData(date);
        return retVal;
      },
      formatDataOra(date) {
        let retVal = '';
        if (date) retVal = Util.formattaDataOra(date);
        return retVal;
      },
    },
  };
</script>
